import { IAppState } from '../../redux';
import { EOfferStatus } from '../../redux/reducers';
import { TEditSource } from '../../types/analytics';

export const selectAnalyticsEditSource = (state: IAppState): TEditSource => {
  const status = state.offer.status;
  const isArchived = state.offer.isArchived;

  if (isArchived) {
    return 'Archive';
  }

  switch (status) {
    case EOfferStatus.published:
      return 'Published';
    case EOfferStatus.draft:
      return 'Draft';
    case EOfferStatus.deactivated:
      return 'Deactivated';
    case EOfferStatus.refused:
      return 'Refused';
    default:
      return 'Other';
  }
};
